<template>
    <div class="hours-by-year">
        <svg :viewBox="'0 0 ' + W + ' ' + H" preserveAspectRatio="xMidYMid meet" role="img" :aria-label="'Clock hours awarded by year'">
            <line :x1="m.l" :x2="W - m.r" :y1="baseY" :y2="baseY" stroke="#c4cfda" stroke-width="1"/>
            <g v-for="bar in bars" :key="bar.year">
                <path :d="bar.path" :fill="bar.current ? '#336699' : '#9dbbd8'"/>
                <text :x="bar.cx" :y="bar.top - 6" text-anchor="middle" class="value-text" :class="{'is-zero': !bar.hours}">{{ bar.hours ? bar.label : '–' }}</text>
                <text :x="bar.cx" :y="H - 8" text-anchor="middle" class="axis-text" :class="{'is-current': bar.current}">{{ bar.year }}</text>
            </g>
        </svg>
    </div>
</template>

<script>
    import {formatHours} from "@/utils/pd";

    // Awarded clock hours per calendar year — one bar each, the current
    // year in the solid brand blue. Dependency-free SVG like the pitch charts.
    export default {
        name: "HoursByYearChart",
        props: {
            rows: {type: Array, default: () => []}, // [{year, hours}]
        },
        data() {
            return {W: 640, H: 170, m: {l: 16, r: 16, t: 26, b: 28}};
        },
        computed: {
            baseY() {
                return this.H - this.m.b;
            },
            bars() {
                const rows = this.rows || [];
                if (!rows.length) return [];
                const max = Math.max(1, ...rows.map(r => r.hours || 0)) * 1.1;
                const slotW = (this.W - this.m.l - this.m.r) / rows.length;
                const barW = Math.min(56, slotW * 0.55);
                const thisYear = new Date().getFullYear();
                return rows.map((r, i) => {
                    const cx = this.m.l + slotW * i + slotW / 2;
                    const x0 = cx - barW / 2;
                    const h = (r.hours || 0) / max * (this.baseY - this.m.t);
                    const top = this.baseY - Math.max(h, r.hours ? 3 : 1.5);
                    const rad = Math.min(4, (this.baseY - top) / 2);
                    const path = 'M' + x0 + ',' + this.baseY +
                        ' L' + x0 + ',' + (top + rad) +
                        ' Q' + x0 + ',' + top + ' ' + (x0 + rad) + ',' + top +
                        ' L' + (x0 + barW - rad) + ',' + top +
                        ' Q' + (x0 + barW) + ',' + top + ' ' + (x0 + barW) + ',' + (top + rad) +
                        ' L' + (x0 + barW) + ',' + this.baseY + ' Z';
                    return {year: r.year, hours: r.hours || 0, label: formatHours(r.hours), cx, top, path, current: r.year === thisYear};
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .hours-by-year svg {
        display: block;
        width: 100%;
        height: auto;
        max-height: 220px;
    }

    .value-text {
        font-size: 12px;
        font-weight: 700;
        fill: #33475b;

        &.is-zero {
            fill: #b3bcc7;
            font-weight: 400;
        }
    }

    .axis-text {
        font-size: 11px;
        fill: #7a8a9d;

        &.is-current {
            fill: #336699;
            font-weight: 700;
        }
    }
</style>
